import axios from "axios"
import baseURL from "../configs/api"

export const post_Vendor = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}vendor?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_Vendor = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}vendor?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}